import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService, } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { FrontDocumentScanImage } from './front-document-scan-image';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var FrontDocumentScanComponent = /** @class */ (function () {
    /**
     * Summary      Constructor of the component.
     *
     * @param {CopyService}                  copyService                Injectable copyService service.
     * @param {AbreCuentasService}           abreCuentasService         Injectable abreCuentasService service.
     * @param {NavigationService}            navigationService          Injectable navigationService service.
     * @param {ChannelCommunicatorService}   channelCommunicatorService Injectable channelCommunicatorService service.
     * @param {IdentificationService}        identificationService      Injectable identificationService service.
     * @param {HeaderService}                headerService              Injectable headerService service.
     * @var   {number}                       maxScanAttempts            Set max scan attempts.
     * @function headerService.show(true,true) Shows header
     * @function setFirstname Sets default first name
     * @function setHeaderSubscribe
     */
    function FrontDocumentScanComponent(copyService, abreCuentasService, navigationService, channelCommunicatorService, identificationService, headerService, taggingService, loaderService) {
        this.copyService = copyService;
        this.abreCuentasService = abreCuentasService;
        this.navigationService = navigationService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.identificationService = identificationService;
        this.headerService = headerService;
        this.taggingService = taggingService;
        this.loaderService = loaderService;
        this.headerService.show(true, true, true);
        this.maxScanAttempts = this.abreCuentasService.getBytteConfig().failedAttempts.frontDocumentScan;
    }
    /**
     * Define la configuración de la imagen una vez el componente es cargada
     *
     * *Sets image configuration once the components is loaded*
     */
    FrontDocumentScanComponent.prototype.ngOnInit = function () {
        this.image = {
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: FrontDocumentScanImage,
        };
    };
    /**
     * Función para la captura de la foto
     *
     * *Capture image function*
     */
    FrontDocumentScanComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.callScanNewVersions()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función para llamar nuevas versiones del escaneo y sus configuraciones
     *
     * *Function to call new scan version and its configurations*
     */
    FrontDocumentScanComponent.prototype.callScanNewVersions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.channelCommunicatorService
                            .getImpl()
                            .verifyAndRequestPermissions()
                            .then(function (p) {
                            if (!p.code || p.code !== '200') {
                                _this.navigationService.navigateToGeneralInformation('401');
                                return;
                            }
                            var channel = _this.channelCommunicatorService.getChannelId();
                            var androidLicense = _this.abreCuentasService.getBytteConfig().licenses[channel].android;
                            var iosLicense = _this.abreCuentasService.getBytteConfig().licenses[channel].ios;
                            var seconds = _this.abreCuentasService.getBytteConfig().timeouts.frontDocumentScan.seconds;
                            return _this.channelCommunicatorService.getImpl().frontDocumentScan(androidLicense, iosLicense, _this.abreCuentasService.getTransactionId(), seconds);
                        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); })
                            .then(function (res) {
                            _this.scanResponse = res;
                            _this.resumeApp();
                        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Casos de respuesta del servicio del escaneo de imagenes
     *
     * *Response cases of the scanning images service*
     */
    FrontDocumentScanComponent.prototype.resumeApp = function () {
        var _this = this;
        switch (this.scanResponse.code) {
            case '400': // Wrong license activation key
            case '403': // Origin not authorized
            case '404': // Operation not found
            case '500': // Internal error
                // this.loaderService.hide();
                this.navigationService.navigateToGeneralInformation('500');
                return;
            case '504': // Failed attempt
                this.abreCuentasService.getAbreCuentasModel().frontDocumentScanAttempts++;
                if (this.abreCuentasService.getAbreCuentasModel().frontDocumentScanAttempts >= this.maxScanAttempts) {
                    this.navigationService.pageLoadTag('No fue posible validar identidad', ['pv223', 'pv119', 'pv79', '']);
                    this.abreCuentasService.caseInfoError('102');
                    this.navigationService.nextStep('102');
                }
                else {
                    this.navigationService.pageLoadTag('Error captura frontal', ['pv221', 'pv112', 'pv72', '']);
                    this.abreCuentasService.setImageLottieError(this.image);
                    this.navigationService.nextStep('112');
                }
                // this.loaderService.hide();
                return;
        }
        this.navigationService.pageLoadTag(false, ['pv13', 'pv104', 'pv63', 'pv13']);
        var tagPageName = this.taggingService.getTagIdByProduct();
        this.pageTagEvent(tagPageName);
        var document = this.abreCuentasService.proccessBase64(this.scanResponse.data.front_document_photo);
        var face = this.abreCuentasService.proccessBase64(this.scanResponse.data.face_photo);
        this.identificationService
            .sendFrontDocumentInfo(document, face)
            .then(function () {
            _this.navigationService.nextStep('200');
        }).catch(function () {
            // this.loaderService.hide();
            _this.navigationService.navigateToGeneralInformation('500');
        });
    };
    /**
     * Servicio para enviar datos a Google analytics
     *
     * *Send data to Google Analytics*
     *
     * @param {string} tagPageName
     */
    FrontDocumentScanComponent.prototype.pageTagEvent = function (tagPageName) {
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].value,
                },
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.image,
                    position: EVENT.customCategory.position.center,
                },
                action: EVENT.customAction.show,
                label: EVENT[tagPageName + "E1customLabel"],
            };
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log(error);
        }
    };
    return FrontDocumentScanComponent;
}());
export { FrontDocumentScanComponent };
